import React from "react";

/**
 * PageHeader — cabecera compacta de página (Iter 48).
 *
 * Cambios respecto a versiones previas:
 *   - Se elimina el pretítulo "Ferretería El Bodegón" (ya visible en el sidebar).
 *   - El título se vuelve opcional (`hideTitle`) y toma tamaño reducido.
 *   - El margen inferior se reduce (mb-4 en vez de mb-8) para recuperar altura.
 *   - Cuando hay `actions` sin título/subtítulo, se alinean a la derecha con altura mínima.
 */
export function PageHeader({ title, subtitle, actions, testid, hideTitle = false }) {
  const showTitleBlock = !hideTitle && (title || subtitle);
  return (
    <div
      className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-4"
      data-testid={testid}
    >
      {showTitleBlock ? (
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-bold tracking-tight truncate">{title}</h1>
          {subtitle && (
            <p className="text-xs text-muted-foreground mt-0.5 max-w-2xl truncate">{subtitle}</p>
          )}
        </div>
      ) : <div />}
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function PageContainer({ children }) {
  return <div className="px-4 sm:px-6 py-4 max-w-[1800px]">{children}</div>;
}
